import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import amplitude from 'service/amplitude';
import { PATH } from 'config';
import Coupon from 'pages/coupon';
import GetRewards from 'pages/get-rewards';
import NotFound from 'pages/not-found';
import 'styles/normalize.sass';
import 'styles/base.sass';
import { AppProvider } from 'use-app';
import Maintenance from 'components/maintenance';
import { MAINTENANCE_CONFIG_URL } from 'config';
import axios from 'axios';

const App = () => {
  const [maintenanceConfig, setMaintenanceConfig] = useState(null);

  useEffect(() => {
    axios
      .get(MAINTENANCE_CONFIG_URL, {
        timeout: 2000,
      })
      .then(res => {
        let data = res.data.default;

        if (data['all'].enabled) {
          setMaintenanceConfig(data['all']);
        } else if (data.hasOwnProperty('web')) {
          setMaintenanceConfig(data['web']);
        } else {
          setMaintenanceConfig({ enabled: false });
        }
      })
      .catch(err => {
        console.log(err);
        setMaintenanceConfig({ enabled: false });
      });
  }, []);

  // 抓取裝置初始高度
  useEffect(() => {
    let h = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${h}px`);

    const onResize = () => {
      let h = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${h}px`);
    };

    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  useEffect(() => {
    amplitude.init();
  }, []);

  if (!maintenanceConfig) {
    return <></>;
  } else if (maintenanceConfig?.enabled) {
    return <Maintenance title={maintenanceConfig.title} content={maintenanceConfig.content} />;
  } else {
    return (
      <AppProvider>
        <Router>
          <Switch>
            <Redirect from={`${PATH.COUPON}/:couponId`} to={`${PATH.COUPON_OLD}/:couponId`} />
            <Route path={PATH.ROOT} exact component={Coupon} />
            <Route path={`${PATH.COUPON_OLD}/:couponId`} component={Coupon} />
            <Route path={`${PATH.GET_REWARDS}/:couponId`} component={GetRewards} />
            <Route component={NotFound} />
          </Switch>
        </Router>
      </AppProvider>
    );
  }
};

export default App;
